import { Component, OnInit } from '@angular/core';
import { QuoteService } from 'src/app/partner-portal/services/quote.service';
import { ProposalService } from 'src/app/partner-portal/services/proposal.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as CryptoJS from 'crypto-js';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PolicyConstant } from 'src/app/partner-portal/Model/policyConstant';
import { MotorService } from '../../../../services/motor.service';

@Component({
  selector: 'app-advance-payment',
  templateUrl: './advance-payment.component.html',
  styleUrls: ['./advance-payment.component.css']
})
export class AdvancePaymentComponent implements OnInit {
  txnid: string;
  responseData: any;
  safeHTML: SafeHtml;
  constructor(private motorService: MotorService, private notificationService: NotificationService, private quoteService: QuoteService, public proposalService: ProposalService, private domSanitizer: DomSanitizer, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.proposalService.paymentDetailsForm = this.proposalService.getPaymentDetailsForm();
     this.proposalService.customerDetailsForm = this.proposalService.getCustomerKYCDetailsForm();
    this.route.queryParams.subscribe(params => {
      if ('txnid' in params) {
        this.txnid = params.txnid;
      }
    })
   
    this.quoteService.getPaymentRequestDetails(this.txnid).subscribe({
      next: async (res) => {
        if (res?.status !== 200) {
          return;
        }

        this.responseData = res.result;

        try {
          const paymentLogic = await this.proposalService.getPaymentPGTypeCheck();
          this.proposalService.paymentDetailsForm.patchValue({
            paymentBy: "Customer",
            amount: this.responseData?.amount,
            paymentDueDate: new Date(),
            paymentMode: PolicyConstant.ADVANCE_PAYMENT_LINK_MOTOR
          });
          this.proposalService.customerDetailsForm.patchValue({
            firstName: this.responseData?.firstName,
            email: this.responseData?.emailAddress,
            mobileNo: this.responseData?.phoneNumber
          });

          let paymentHTML = await this.proposalService.getGatewayPayU(PolicyConstant.ADVANCE_PAYMENT_LINK_MOTOR, this.responseData?.agentId, this.responseData?.officeCode,this.responseData?.transactionId);

          if (paymentLogic?.udf1 === "0") {
            this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(paymentHTML);
            const myWindow = window.open('', '_self');
            myWindow.document.write(paymentHTML);
          }
          else if (paymentLogic?.udf1 === "1") {
            paymentHTML = JSON.parse(paymentHTML);
            if (paymentHTML?.status !== '200') {
              this.notificationService.showError('Failed to get Payment Window!', 'Failed!');
            } else {
              const myWindow = window.open(paymentHTML?.redirectUrl, '_self');
            }
          }
        } catch (error) {
          console.error('Payment processing failed:', error);
        }
      },
      error: (err) => {
        console.error('API Error:', err);
      }
    });

    this.quoteService.getPaymentRequestDetails(this.txnid).subscribe(async res => {
      if (res.status === 200) {
        this.responseData = res.result;
        const paymentLogic = await this.proposalService.getPaymentPGTypeCheck();
        let paymentHTML = await this.proposalService.getGatewayPayU(PolicyConstant.Motor);

        if (paymentLogic.udf1 === "0") {
          if (!paymentHTML) {
          } else {
            this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(paymentHTML);
            const myWindow = window.open('', '_self');
            myWindow.document.write(paymentHTML);
          }
        }
        else {
          paymentHTML = JSON.parse(paymentHTML);
          if (paymentHTML?.status !== '200') {
          } else {
            const myWindow = window.open(paymentHTML?.redirectUrl, '_self');
          }
        }
      }
    });
    console.log(this.responseData, "sdfsdf");
  }


}